import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId } from '../../types/api/primaryKeys/PrimaryKey';
import { PackageSummaryPolicy } from '../../types/api/enrollmentPackages/PackageSummaryPolicy';
import { PackageSummaryPerson } from '../../types/api/enrollmentPackages/PackageSummaryPerson';

export async function getPackageSummaryPeople(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<readonly PackageSummaryPerson[]>(`packages/${packageId}/summarypeople`);
    return result;
}

export async function getPackageSummaryPolicies(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<readonly PackageSummaryPolicy[]>(`packages/${packageId}/summarypolicies`);
    return result;
}